import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { editSizeOfItem } from 'swag-client-common/redux/cart/cart.actions';
import { isSizeEditorPopupShownSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { cartItemToEditSelector } from '../../../redux/cart/cart.selectors';
import SizeEditorPopup from './size-editor-popup';
const mapStateToProps = createStructuredSelector({
  item: cartItemToEditSelector,
  open: isSizeEditorPopupShownSelector
});
const mapDispatchToProps = dispatch => ({
  onSave: item => {
    dispatch(editSizeOfItem({
      item
    }));
  },
  onClose: () => {
    dispatch(hidePopup());
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(SizeEditorPopup);